module.exports = __webpack_public_path__ + "img/logo-cbgr-full.3d1c6007.png";